import { render, staticRenderFns } from "./TopNotice.vue?vue&type=template&id=3bc27f67"
import script from "./TopNotice.vue?vue&type=script&lang=js"
export * from "./TopNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports